export const MSG_COUPON_IN_APP = `안드로이드 웨이브 앱에서 결제 연동 프로모션 쿠폰의 등록 및 사용이 불가능합니다.\n웨이브 홈페이지에서 진행해 주시기를 바랍니다.`
export const MSG_COUPON_INVALID =
  '유효한 쿠폰번호가 아닙니다. 쿠폰번호를 다시 확인해 주세요.'
export const MSG_INVALID_EMAIL = '올바른 형식의 이메일 주소를 입력 해주세요.'
export const MSG_USING_COUPON_ALREADY =
  '현재 Wavve 서비스를 구독중이므로,\n프로모션 쿠폰을 사용할 수 없습니다.\n\nMY/이용권내역에서 이용권 자동 결제를 해지하고,\n이용 기간 만료 후에 쿠폰을 사용하세요.'
export const MSG_CHECK_PURCHASE_NETWORK_ERROR =
  '일시적인 통신 오류나 서버 점검 때문에\n이용권 변경에 실패했습니다.\n잠시 후 다시 시도해주세요.'
export const MSG_CHECK_PURCHASE_IN_APP_ALERT =
  '프로모션 쿠폰 이용 시\niOS나 안드로이드 인앱 결제로\n이용권 구매 변경이 불가합니다.'
export const MSG_COUPON_SERVER_ERROR =
  '일시적인 통신 오류 입니다. 잠시 후 다시 시도해주세요.'

export const COUPON_NOTIFICATION_LIST = [
  '등록하신 쿠폰은 환불되지 않습니다.',
  '쿠폰은 상업적 용도로 사용하거나 매매하실 수 없습니다.',
  '유효기간이 지난 쿠폰은 등록하실 수 없습니다.',
  '자동 결제 연동이 필요한 프로모션 쿠폰 사용 중에는\n다른 할인 이벤트가 노출되지 않을 수 있으며, 구독 또한 불가합니다.',
  '쿠폰으로 지급되는 상품은 기존 보유 상품과 중복되어 적용되므로 가급적 이용중인 상품이 만료 된 뒤에 쿠폰을 사용해 주세요.',
  '쿠폰번호에 숫자 0,1은 없습니다. 영문자 O,I와 혼동하지 않도록 유의해 주세요.',
]
